module.exports = __webpack_public_path__ + "static/img/2.bd2ff7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R407C/2.jpg
// module id = K/r6
// module chunks = 1